// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__4AGTw","content":"RecentSearches_content__1aTJF"};